export class Click {
  navigate(to) {
    const url = new URL('/click', window.location.origin);
    url.searchParams.set('from', document.referrer || window.location.href);
    url.searchParams.set('to', to);

    window.open(url.toString(), '_blank');
  }
}
